import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CoordinationResultStudyFormModel } from '../../models/coordination-result-study-form-model';
import { FormGroupType } from '../../../../../../core/models/form-group-type';

@Injectable({
    providedIn: 'root',
})
export class CoordinationResultStudyFormService {
    getFormDefinition(): FormGroup<
        FormGroupType<CoordinationResultStudyFormModel>
    > {
        return new FormGroup<FormGroupType<CoordinationResultStudyFormModel>>({
            id: new FormControl<number>(0),
            isSelected: new FormControl<boolean>(false),
            autoCoordRank: new FormControl<number | null>(null),
            testFreq: new FormControl<number | null>(null),
            autoCoordStatusCode: new FormControl<string | null>(null),
            totalPositiveOvpP: new FormControl<number | null>(null),
            comments: new FormControl<string | null>(null),
        });
    }
}
